import {HttpHeaders} from '@angular/common/http';
import {environment} from "../environments/environment";

export class AppSettings {
  
  /*copy this function */
  public static get PATH(): string {
    return `${environment.Url}`;
  }
  
  public static get IMAGE(): string {
    return `${environment.Image}`;
  }
  
  // socket
  public static get SOCKET_PATH(): string {
    return `${environment.Socket}`;
  }
  
  // href
  public static get Href(): string {
    return `${environment.Url}`;
  }
  
  public static get API_ENDPOINT(): string {
    return `${environment.apiUrl}`;
  }
  
  public static get IFRAME(): string {
    return `${environment.iframe}`;
  }
  
  public static get isProd(): boolean {
    return environment.production;
  }
  
  
  public static get API_KEY(): string {
    return 'b7ndJ9hXmg69DdDIj2nsd9h82bLbf72aasGSD82L8g8';
  }
  
  public static get Google_API_KEY(): string {
    return 'AIzaSyBk7woY5Ez1X4YN_-o10FCycrGeyJC9QZY';
  }
  
  public static get API_SECRET(): string {
    return 'n8nfa8sdbo38fb3fbefb38n18ofno1n3f8ob13fobv';
  }
  
  public static get API_VERSION(): string {
    return 'v0.1';
  }
  
  
  public static getRequestOptions() {
    let tempHeaders = {
      'Content-Type': 'application/json',
      'Location': ''
    }
    const httpOptions = {
      headers: new HttpHeaders(tempHeaders)
    };
    return httpOptions;
  }
  
  
}
